import { graphql } from 'relay-runtime'
import styled from '@emotion/styled'
import { useFragment } from 'react-relay'
import { CreativeList$key } from './__generated__/CreativeList.graphql'
import MetaAd from './MetaAd/MetaAd'
import CreateNewMetaAdElement from './CreateNewMetaAdElement'
import { EmptyState } from '../../components/EmptyState/EmptyState'
import { HomeListType, useTypeParam } from '../../state/url/type'
import { ListSelectionReset } from '../../components/SelectableItemList/context'

interface CreativeListProps {
  fragmentRequest: CreativeList$key
}

export const creativeListFragment = graphql`
  fragment CreativeList on Brand {
    metaAds(metaAdsFilter: $metaAdsFilter) {
      id
      ...MetaAd
    }
  }
`

const S = {
  Wrapper: styled.div`
    padding: 1rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    & > * {
      margin: 0 1rem 1rem 0;
    }
  `,
  EmptyStateWrapper: styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  `,
  ButtonWrapper: styled.div`
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  `,
}

const CreativeList = ({ fragmentRequest }: CreativeListProps) => {
  const brand = useFragment(creativeListFragment, fragmentRequest)
  const [type] = useTypeParam()

  let body
  if (brand.metaAds.length === 0 && type !== HomeListType.DRAFT.toString()) {
    body = (
      <S.EmptyStateWrapper>
        <EmptyState
          message={`It looks like there aren't any ${type?.toLowerCase()} ads in this account.`}
        />
      </S.EmptyStateWrapper>
    )
  } else {
    body = brand.metaAds.map((it) => (
      <MetaAd key={it.id} fragmentRequest={it} />
    ))
    if (type === HomeListType.DRAFT.toString()) {
      body.unshift(<CreateNewMetaAdElement key={-1} />)
    }
  }
  return (
    <>
      <S.Wrapper>{body}</S.Wrapper>
      <ListSelectionReset key={type} />
    </>
  )
}

export default CreativeList
